<template>
    <header class="header-block" id="header" ref="headerRef">
        <div class="header-block__container">
            <div class="header-block__wrapper">
                <div class="header-block__logo-wrapper">
                    <a href="/" class="header-block__logo">
                        <img alt="kmc-logo" src="@/assets/img/header-logo.webp">
                    </a>
                    <a href="https://kgforum.kz/" target="_blank">
                        <img src="@/assets/img/kgf-logo-small.webp" alt="KGF"></img>
                    </a>
                    <a href="https://creativity.kz/" target="_blank">
                        <img src="@/assets/img/au_logo.svg" style="transform: rotate(180deg)" alt="AU"></img>
                    </a>
                </div>
                <nav class="header-block__nav">
                    <a href="#about" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.about_forum') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#program" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.program') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#tickets" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.tickets') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#tickets" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.registration') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#nominations" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.nominations') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#survey" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.survey') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#speakers" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.speakers') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#organizers" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.organizers') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#partners" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.partners') }}</a>
                    <div class="header-block__nav-separation">/</div>
                    <a href="#footer" v-smooth-scroll class="header-block__nav-link">{{ $t('2026.header.contacts') }}</a>
                </nav>
                <div class="header-block__locale">
                    <a-select
                        v-model:value="$i18n.locale"
                        class="header-block-lang-select"
                        :bordered="false"
                        :show-arrow="false"
                        :dropdownMatchSelectWidth="false"
                        @change="select_lang"
                    >
                        <a-select-option value="ru">RU</a-select-option>
                        <a-select-option value="kz">KZ</a-select-option>
                    </a-select>
                </div>
                
                <div class="header-block__burger" @click="toggleMenu">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
        <drawer v-model:open="isMenuOpen" class="header-block-main" placement="right">
            <div class="header-block__menu-mobile">
                <div class="header-block__locale-mobile">
                    <a-select
                        v-model:value="$i18n.locale"
                        class="header-block-lang-select"
                        :bordered="false"
                        :show-arrow="false"
                        :dropdownMatchSelectWidth="false"
                        @change="select_lang"
                    >
                        <a-select-option value="ru">RU</a-select-option>
                        <a-select-option value="kz">KZ</a-select-option>
                    </a-select>
                </div>
                <div class="header-block__menu-mobile-links">
                    <a href="#about" v-smooth-scroll class="header-block__menu-mobile-link" >{{ $t('2026.header.about_forum') }}</a>
                    <a href="#program" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.program') }}</a>
                    <a href="#tickets" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.tickets') }}</a>
                    <a href="#tickets" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.registration') }}</a>
                    <a href="#nominations" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.nominations') }}</a>
                    <a href="#survey" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.survey') }}</a>
                    <a href="#speakers" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.speakers') }}</a>
                    <a href="#organizers" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.organizers') }}</a>
                    <a href="#partners" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.partners') }}</a>
                    <a href="#footer" v-smooth-scroll class="header-block__menu-mobile-link">{{ $t('2026.header.contacts') }}</a>
                </div>
                <div class="header-block__menu-mobile-socials">
                    <a href="https://www.instagram.com/marketingconference.kz" target="_blank">
                        <img src="@/assets/img/social/instagram-green.svg" alt="instagram">
                    </a>
                    <a href="https://t.me/kgfnewscentras" target="_blank">
                        <img src="@/assets/img/social/telegram-green.svg" alt="telegram">
                    </a>
                    <a href="https://www.youtube.com/@KazakhstanGrowthForum" target="_blank">
                        <img src="@/assets/img/social/youtube-green.svg" alt="youtube">
                    </a>
                    <a href="https://www.facebook.com/groups/KazakhstanGrowthForum/" target="_blank">
                        <img src="@/assets/img/social/facebook-green.svg" alt="facebook">
                    </a>
                </div>
                <div class="header-block__menu-mobile-contacts">
                    
                        <div style="display: flex; flex-direction: row; align-items: center;">
                            <img src="@/assets/img/social/header-whatsapp-white.svg" alt="whatsapp">
                            <div class="header-block__menu-mobile-contact">+ 7 (701) 428-84-90</div>
                        </div>
                        <div style="display: flex; flex-direction: row;">
                            <img src="@/assets/img/social/header-phone.svg" alt="phone">
                            <div class="header-block__menu-mobile-contact">+ 7 (701) 428-84-90</div>
                        </div>
                        <div style="display: flex; flex-direction: row;">
                            <img src="@/assets/img/social/header-mail-white.svg" alt="mail">
                            <div class="header-block__menu-mobile-contact">marketing@kgforum.kz</div>
                        </div>   
                    
                </div>
            </div>
        </drawer>
    </header>
</template>
<script >
import { ref, onMounted, onUnmounted } from 'vue';
import Drawer from './Drawer.vue';



// window.onscroll = function() {scrollFunction()};


// function scrollFunction() {
//   if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 100) {
//     document.getElementById("header").classList.add("active");
//   } else {
//     document.getElementById("header").classList.remove("active");
//   }
// }
export default {
    name: 'HeaderBlock',
    components: {
        Drawer
    },
    setup() {
        const language = ref('ru');

        const isMenuOpen = ref(false);

        const headerRef = ref(null);

        const onScroll = () => {
        if (!headerRef.value) return;

        const scrolled =
            document.body.scrollTop > 50 ||
            document.documentElement.scrollTop > 100;

        headerRef.value.classList.toggle('active', scrolled);
        };

        onMounted(() => {
        window.addEventListener('scroll', onScroll);
        });

        onUnmounted(() => {
        window.removeEventListener('scroll', onScroll);
        });

        const toggleMenu = () => {
            isMenuOpen.value = !isMenuOpen.value;
        };
        
        return {
            headerRef,
            language,
            isMenuOpen,
            toggleMenu
        };
    },
    methods: {
        select_lang(lang) {
            this.$i18n.locale = lang;
        },
    }
}

</script>
<style lang="scss">
.header-block {
    box-sizing: border-box;
    background-color: transparent;
    position: fixed;
	width: 100%;
    height: 100px;
	z-index: 5;
    border-bottom: 0.5px solid rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, 1);
    font-family: 'GT Eesti Pro Display Light';
    line-height: 120%;
    display: flex;
    align-items: center;
    @media(max-width: 480px) {
        padding: 0 30px;
    }
    &__container {
        max-width: 1440px;
        width: 100%;
        margin: 0 auto;
        @media(max-width: 1440px) {
            padding: 0 20px;
        }
        @media(max-width: 480px) {
            padding: 0;
        }

    }
    &__wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__logo-wrapper {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        @media(max-width: 480px) {
            gap: 5px;	
        }
    }

    &__logo {
		display: flex;
		width: 89px;
		height: 32px;

		img {
			max-width: 100%;
			height: auto;
		}

		@media screen and (max-width: 768px) {
			width: 139px;
			height: 50px;
		}

        @media screen and (max-width: 480px) {
			width: 108px;
			height: 39px;
		}
        @media screen and (max-width: 380px) {
			width: 98px;
			height: 29px;
		}
	}


    &__nav {
        display: flex;
        gap: 10px;
        align-items: center;
        font-size: 13px;

        &-link {
            color: white;
            text-decoration: none;
            text-transform: uppercase;
            &:hover {
                color: white;    
            }
        }

        @media screen and (max-width: 1500px) {
			font-size: 10px;
		}
        @media screen and (max-width: 120px) {
            gap: 5px;
		}
    }


    &__burger {
        display: none;    
    }

    &__menu-mobile {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px 20px;
    }
    &__menu-mobile-links {
        display: flex;
        flex-direction: column;  
        align-items: center; 
        gap: 20px; 
        margin-bottom: 60px;
        @media screen and (max-width: 940px) {
			gap: 20px; 
            margin-bottom: 40px;
		}
    }
    &__menu-mobile-link {
        font-family: 'GT Eesti Pro Display Regular'; 
        font-size: 36px; 
        text-transform: uppercase;  
        color: #F6F9FC;
        &:active {
            color: #62D4E3;
        }
        @media screen and (max-width: 768px) {
			font-size: 30px;
		}
        @media screen and (max-width: 480px) {
			font-size: 22px;
		}
    }
    &__menu-mobile-socials {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;  
        gap: 60px; 
        @media screen and (max-width: 480px) {
			gap: 20px;
		}
    }
    &__menu-mobile-contacts {
        max-width: 600px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 30px;
        justify-content: center; 
        color: #F6F9FC;
        font-family: 'GT Eesti Pro Display Regular'; 
        font-size: 20px;   
        margin-top: 40px; 
    }
    &__menu-mobile-contact {
        margin-bottom: -5px;
        margin-left: 10px;
    }

    @media screen and (max-width: 1150px) {
        .header-block__nav,
        .header-block__locale {
            display: none;
        }

        .header-block__burger {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            span{
                background-color: #fff;
                height: 4px;
                width: 38px;
                margin-bottom: 8px;
            }
        }
    }
}

.header-block.active {
    background-color: rgba(17, 21, 24, .6);
}

.header-block-lang-select {
    min-width: 50px;

    .ant-select-selector {
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
    }

        .ant-select-selection-item {
            font-family: 'Goldman Bold';
            font-weight: 800;
            font-size: 16px;
            color: #ffffff;
            text-decoration: underline;
            text-underline-offset: 4px;
        }

    .ant-select-arrow {
        display: none !important;
    }

    .ant-select-dropdown {
        background-color: rgba(17, 21, 24, 0.95);
    }

    .ant-select-item-option-content {
        color: #ffffff;
        font-weight: 700;
    }

    .ant-select-item-option-selected {
        background-color: transparent !important;
    }
}

.header-block__locale-mobile {
    margin-bottom: 20px;
    .ant-select-selection-item {
        font-family: 'Goldman Bold';
        font-weight: 800;
        font-size: 22px;
        color: #ffffff;
        text-decoration: underline;
        text-underline-offset: 4px;
    }
}

@font-face {    
    font-family: 'GT Eesti Pro Display Light';
    src: url('/src/assets/fonts/gteestiprodisplay_light.otf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {    
    font-family: 'GT Eesti Pro Display Regular';
    src: url('/src/assets/fonts/gteestiprodisplay_regular.otf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {    
    font-family: 'GT Eesti Pro Display Bold';
    src: url('/src/assets/fonts/gteestiprodisplay_bold.otf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
@font-face {    
    font-family: 'Goldman Bold';
    src: url('/src/assets/fonts/Goldman-Bold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {    
    font-family: 'Goldman Regular';
    src: url('/src/assets/fonts/Goldman-Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}
</style>